import { Box, Container } from "@chakra-ui/react";
import React from "react";

interface IAuthLayoutProps {
  children: React.ReactNode;
}

const AuthLayout: React.FC<IAuthLayoutProps> = ({ children }) => {
  return (
    <Box
      maxWidth="100%"
      bg="#ffffff"
      minHeight="100dvh"
      width="100%"
      position="relative"
      overflow="hidden"
    >
      <Container
        position="relative"
        zIndex={1}
        maxWidth="container.2xl"
        px={0}
        minHeight="100dvh"
      >
        {children}
      </Container>
    </Box>
  );
};

export default AuthLayout;
